module.exports = __webpack_public_path__ + "img/IN_DT.4a784423.svg";